import { createStyles, Grid, makeStyles } from '@material-ui/core';
import React from 'react';

import { TnTypography } from '../../TnTypography';
import { HirevueQuestion } from '../types';

interface IProps {
  question: HirevueQuestion;
}

const useStyles = makeStyles(() =>
  createStyles({
    answerContainer: {
      flexDirection: 'column',
    },
    videoContainer: {
      width: '100%',
      height: 300,
      marginTop: 16,
    },
  }),
);

const VideoQuestion: React.FC<IProps> = ({ question }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.answerContainer} container justify="center" xs={6}>
      <TnTypography variant="caption">{question.text}</TnTypography>
      <video className={classes.videoContainer} src={question?.video} controls>
        <track kind="captions" />
      </video>
    </Grid>
  );
};

export default VideoQuestion;
